export default "__VITE_ASSET__jbK_wc1x__"